export default __webpack_public_path__ + "fonts/loan-geek-full-logo.svg";